import { translate } from "$lib/utilities/translate";
import { getLangHref } from "$lib/utilities/getLangHref";

export const getActionObject = (data, lang, area, col, settingId, theme, key) => {
	const content = data?.content?.[col]?.[settingId] || {};

	const actionHref = getLangHref(
		content?.[key]?.value?.href?.value || content?.[`${key}Href`]?.value,
		lang,
		area,
	);
	const actionClass =
		content?.classes?.value?.[`${key}Class`]?.value || "btn-outline";
	const actionStyle = content?.styles?.value?.[key]?.value.replace(
		/\+\:\+/g,
		":",
	);
	const actionLayers = content?.classes?.value?.[`${key}Layers`]?.value;
	const actionStyles = content?.styles?.value?.[`${key}Layers`]?.value.replace(
		/\+\:\+/g,
		":",
	);
	const actionImageLight =
		content?.[`${key}ImageLight`]?.value || content?.[`${key}Image`]?.value;
	const actionImageDark =
		content?.[`${key}ImageDark`]?.value || content?.[`${key}Image`]?.value;
	const actionIcon = JSON.parse(content?.[`${key}Icon`]?.value?.icon || "{}");
	const getImage = t => {
		if (t === 'light') return actionImageLight;
		if (t === 'dark') return actionImageDark;
	};
	const actionImage = getImage(theme);
	const actionImageClass = content?.classes?.value?.[`${key}ImageClass`]?.value;
	const imageLoading = content?.[`${key}ImageLoading`]?.value || 'eagar';
	const action = {
		label: translate(content?.[key]?.value?.label, lang),
		description: translate(content?.[key]?.value?.description, lang),
		actionHref,
		actionClass,
		actionImage,
		actionIcon,
		imageClass: actionImageClass,
		imageLoading,
		actionLayers,
		actionStyles,
		style: actionStyle,
	};

	return action;
};
